<template>
  <div class="eu-flex-item eu-basis_6">
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ title }}
    </p>
    <p class="emd-card-grid__line">
      {{ bankName }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodBank',

  props: {
    title: {
      type: String,
      required: true
    },
    bank: {
      type: [String, Number],
      required: true
    }
  },

  data () {
    return {
      banks: {
        '001': 'Banco do Brasil',
        237: 'Bradesco',
        399: 'HSBC',
        341: 'Itaú',
        '033': 'Santander',
        174: 'Pefisa',
        104: 'Caixa Econômica',
        376: 'JP Morgan',
        198: 'Pagar.me'
      }
    }
  },

  computed: {
    bankName () {
      return this.banks[this.bank] || '-'
    }
  }
}
</script>
